export default "__VITE_ASSET__Bdkjdbt$__"